export enum EAdminViewName {
  INDEX = "index",
  CLIENTES = "clientes",
  USUARIOS = "usuarios",
  VAN_CONFIG = "VanConfig",
  LEAD = "lead",
  INTEGRACOES = "integracoes",
  REGRAS_CO = "regrasco",
  NOTIFICACOES = "notificacoes",
  GESTAO_CONTRATOS = "gestaoContratos",
  GESTAO_CONTRATOS_GERENCIAMENTO = "gestaoContratosGerenciamento",
  GESTAO_CONTRATOS_HISTORICO_ACEITES = "gestaoContratosHistoricoAceites",
  FEATURE_FLAGS = "featureFlags",
  CUPONS = "cupons"
}
